/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkIngressCheckHealth } from "../funcs/networkIngressCheckHealth.js";
import { networkIngressCreateIngress } from "../funcs/networkIngressCreateIngress.js";
import { networkIngressDeleteIngress } from "../funcs/networkIngressDeleteIngress.js";
import { networkIngressGetDeleteImpact } from "../funcs/networkIngressGetDeleteImpact.js";
import { networkIngressGetIngress } from "../funcs/networkIngressGetIngress.js";
import { networkIngressRotateCredentials } from "../funcs/networkIngressRotateCredentials.js";
import { networkIngressUpdateIngress } from "../funcs/networkIngressUpdateIngress.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { NetworkIngress as NetworkIngress$Model } from "../models/components/networkingress.js";
import { NetworkIngressDeleteImpact } from "../models/components/networkingressdeleteimpact.js";
import { NetworkIngressResult } from "../models/components/networkingressresult.js";
import {
  CheckNetworkIngressHealthRequest,
  CheckNetworkIngressHealthSecurity,
} from "../models/operations/checknetworkingresshealth.js";
import {
  CreateNetworkIngressRequest,
  CreateNetworkIngressSecurity,
} from "../models/operations/createnetworkingress.js";
import {
  DeleteNetworkIngressRequest,
  DeleteNetworkIngressSecurity,
} from "../models/operations/deletenetworkingress.js";
import {
  GetNetworkIngressRequest,
  GetNetworkIngressSecurity,
} from "../models/operations/getnetworkingress.js";
import {
  GetNetworkIngressDeleteImpactRequest,
  GetNetworkIngressDeleteImpactSecurity,
} from "../models/operations/getnetworkingressdeleteimpact.js";
import {
  RotateNetworkIngressCredentialsRequest,
  RotateNetworkIngressCredentialsSecurity,
} from "../models/operations/rotatenetworkingresscredentials.js";
import {
  UpdateNetworkIngressRequest,
  UpdateNetworkIngressSecurity,
} from "../models/operations/updatenetworkingress.js";
import { unwrapAsync } from "../types/fp.js";

export class NetworkIngress extends ClientSDK {
  /**
   * checkHealth networkIngress
   *
   * @remarks
   * Signal reconciliation and return the latest observed ingress health.
   */
  async checkHealth(
    request?: CheckNetworkIngressHealthRequest | undefined,
    security?: CheckNetworkIngressHealthSecurity | undefined,
    options?: RequestOptions,
  ): Promise<NetworkIngress$Model> {
    return unwrapAsync(networkIngressCheckHealth(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createIngress networkIngress
   *
   * @remarks
   * Create the organization's Tailscale ingress. Provider credentials are encrypted and never returned.
   */
  async createIngress(
    request: CreateNetworkIngressRequest,
    security?: CreateNetworkIngressSecurity | undefined,
    options?: RequestOptions,
  ): Promise<NetworkIngress$Model> {
    return unwrapAsync(networkIngressCreateIngress(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteIngress networkIngress
   *
   * @remarks
   * Soft-delete the ingress and retain provider identities until cleanup is confirmed.
   */
  async deleteIngress(
    request?: DeleteNetworkIngressRequest | undefined,
    security?: DeleteNetworkIngressSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(networkIngressDeleteIngress(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getIngress networkIngress
   *
   * @remarks
   * Get the active network ingress for the current organization, when configured.
   */
  async getIngress(
    request?: GetNetworkIngressRequest | undefined,
    security?: GetNetworkIngressSecurity | undefined,
    options?: RequestOptions,
  ): Promise<NetworkIngressResult> {
    return unwrapAsync(networkIngressGetIngress(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getDeleteImpact networkIngress
   *
   * @remarks
   * Count hosted MCP servers that retain dual or private-only modes after ingress deletion.
   */
  async getDeleteImpact(
    request?: GetNetworkIngressDeleteImpactRequest | undefined,
    security?: GetNetworkIngressDeleteImpactSecurity | undefined,
    options?: RequestOptions,
  ): Promise<NetworkIngressDeleteImpact> {
    return unwrapAsync(networkIngressGetDeleteImpact(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * rotateCredentials networkIngress
   *
   * @remarks
   * Replace the provider OAuth client credentials without returning either value.
   */
  async rotateCredentials(
    request: RotateNetworkIngressCredentialsRequest,
    security?: RotateNetworkIngressCredentialsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<NetworkIngress$Model> {
    return unwrapAsync(networkIngressRotateCredentials(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateIngress networkIngress
   *
   * @remarks
   * Update desired ingress settings. Enabling is expansion-gated; disabling remains available after gate removal.
   */
  async updateIngress(
    request: UpdateNetworkIngressRequest,
    security?: UpdateNetworkIngressSecurity | undefined,
    options?: RequestOptions,
  ): Promise<NetworkIngress$Model> {
    return unwrapAsync(networkIngressUpdateIngress(
      this,
      request,
      security,
      options,
    ));
  }
}
